
import { useState, useEffect } from "react";
import { Footer } from "../../layouts/footer";
import { CreditCard, DollarSign, Package, TrendingUp, Users } from "lucide-react";
import config from '../../../config';
import CryptoJS from 'crypto-js';

const DashboardPage = () => {
  const [counts, setCounts] = useState({
    products: 0,
    categories: 0,
    users: 0,
    order: 0,
  });
  // Your encryption key (must match the backend key)
  const ENCRYPTION_KEY = '000102030405060708090a0b0c0d0e0f101112131415161718191a1b1c1d1e1f';

  const decryptData = (encryptedData) => {
    try {
        // Convert hex key to WordArray
        const key = CryptoJS.enc.Hex.parse(ENCRYPTION_KEY);
        
        // Decode base64
        const decoded = CryptoJS.enc.Base64.parse(encryptedData);
        const decodedStr = CryptoJS.enc.Latin1.stringify(decoded);
        
        // Extract IV (first 16 bytes) and ciphertext
        const iv = CryptoJS.enc.Latin1.parse(decodedStr.substr(0, 16));
        const ciphertext = CryptoJS.enc.Base64.parse(
            CryptoJS.enc.Latin1.parse(decodedStr.substr(16)).toString(CryptoJS.enc.Base64)
        );
        
        // Decrypt
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: ciphertext },
            key,
            { 
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        
        if (!decryptedText) {
            throw new Error("Decryption failed - empty result");
        }
        
        return JSON.parse(decryptedText);
    } catch (error) {
        console.error("Decryption error:", error);
        return null;
    }
};
 useEffect(() => {
    const fetchCounts = async () => {
    try {
        const [productsRes, categoriesRes, usersRes, orderRes] = await Promise.all([
            fetch(`${config.baseURL}/products_count`).then((res) => res.text()),
            fetch(`${config.baseURL}/categories_count`).then((res) => res.text()),
            fetch(`${config.baseURL}/users_count`).then((res) => res.text()),
            fetch(`${config.baseURL}/orderd_product`).then((res) => res.text()),
        ]);

        setCounts({
            products: decryptData(productsRes)?.count || 0,
            categories: decryptData(categoriesRes)?.count || 0,
            users: decryptData(usersRes)?.count || 0,
            order: decryptData(orderRes)?.count || 0,
        });
    } catch (error) {
        console.error("Error fetching counts:", error);
    }
};

    fetchCounts();
  }, []);

  return (
    <div className="flex flex-col h-full">
      <div className="flex-grow flex flex-col gap-y-4 pb-4">
      <h1 className="title">Dashboard</h1>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <div className="card">
          <div className="card-header">
            <div className="w-fit rounded-lg bg-blue-500/20 p-2 text-blue-500 transition-colors dark:bg-blue-600/20 dark:text-blue-600">
              <Package size={26} />
            </div>
            <p className="card-title">Total Products</p>
          </div>
          <div className="card-body bg-slate-100 transition-colors dark:bg-slate-950">
            <p className="text-3xl font-bold text-slate-900 transition-colors dark:text-slate-50">
              {counts.products}
            </p>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <div className="w-fit rounded-lg bg-blue-500/20 p-2 text-blue-500 transition-colors dark:bg-blue-600/20 dark:text-blue-600">
              <CreditCard size={26} />
            </div>
            <p className="card-title">Total Categories</p>
          </div>
          <div className="card-body bg-slate-100 transition-colors dark:bg-slate-950">
            <p className="text-3xl font-bold text-slate-900 transition-colors dark:text-slate-50">
              {counts.categories}
            </p>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <div className="rounded-lg bg-blue-500/20 p-2 text-blue-500 transition-colors dark:bg-blue-600/20 dark:text-blue-600">
              <Users size={26} />
            </div>
            <p className="card-title">Total Users</p>
          </div>
          <div className="card-body bg-slate-100 transition-colors dark:bg-slate-950">
            <p className="text-3xl font-bold text-slate-900 transition-colors dark:text-slate-50">
              {counts.users}
            </p>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <div className="rounded-lg bg-blue-500/20 p-2 text-blue-500 transition-colors dark:bg-blue-600/20 dark:text-blue-600">
              <TrendingUp size={26} />
            </div>
            <p className="card-title">Total Order</p>
          </div>
          <div className="card-body bg-slate-100 transition-colors dark:bg-slate-950">
            <p className="text-3xl font-bold text-slate-900 transition-colors dark:text-slate-50">
              {counts.order}
            </p>
          </div>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
};

export default DashboardPage;
